import styles from './RequestTypeForms.module.scss';
import SelectDropdown from '../../../../utils/SelectDropdown';
import { frequencyOptions } from '../../../../components/body/support/forms/shared/FormsData';
import { useState } from 'react';
import {
  normalizeInput,
  validateCode,
} from '../../../../components/body/checkout/sections/checkoutUtils';
import { useForm } from 'react-hook-form';
import { useAppDispatch } from '../../../../src/app/hooks';
import { submitSupportTicket } from '../../../../src/features/user/userState';
import { getValidationMessage } from '../../../../commons/utils';
import { validationTypes } from '../../../../commons/validations';
import {
  cleanEmailField,
  cleanNameField,
  phoneNumberLengthValidation,
  processEmailField,
  processNameField,
} from '../../../../commons/formatters';
import { removeCountryCodeAndFormat } from '../../../../commons/utils/utils';
import {
  COMMENTS_REGISTER,
  EMAIL_REGISTER,
  FN_REGISTER,
  LN_REGISTER,
  PHONE_REGISTER,
  ZIP_REGISTER,
} from '../../../../commons/Constants';
import { ContainedButton, TextInput } from '../../../../commons/hoc';
import TextAreaInput from '../../../../commons/hoc/Input/TextAreaInput/TextAreaInput';

const FrequencyForm = ({ setFormSubmitted = () => {} }) => {
  const dispatch = useAppDispatch();
  const [radioButtonState, setRadioButtonState] = useState(true);

  const {
    register,
    formState: { errors },
    handleSubmit,
    clearErrors,
    setValue,
  } = useForm({ mode: 'onBlur', reValidateMode: 'onBlur' });
  const onSubmit = (data) => {
    dispatch(
      submitSupportTicket({
        'qmonitorid': '30f',
        'firstname': data.firstName,
        'lastname': data.lastName,
        'phone': removeCountryCodeAndFormat(data.phone, true),
        'email': data.email,
        'Custom[643]': data.zip,
        'Custom[645]': data.frequency,
        'message': data.comments,
        'Custom[977]': radioButtonState,
      })
    );
    setFormSubmitted(true);
  };

  const [phoneNumber, setPhoneNumber] = useState('');
  const [zipCode, setZipCode] = useState('');

  const firstName = register(FN_REGISTER, {
    ...validationTypes.firstName,
    onChange: (e) => {
      e.target.value = processNameField(e.target.value);
      setValue(FN_REGISTER, e.target.value);
      clearErrors(FN_REGISTER);
    },
    onBlur: (e) => {
      setValue(FN_REGISTER, cleanNameField(e.target.value));
    },
  });

  const lastName = register(LN_REGISTER, {
    ...validationTypes.lastName,
    onChange: (e) => {
      e.target.value = processNameField(e.target.value);
      setValue(LN_REGISTER, e.target.value);
      clearErrors(LN_REGISTER);
    },
    onBlur: (e) => {
      setValue(LN_REGISTER, cleanNameField(e.target.value));
    },
  });

  const phone = register(PHONE_REGISTER, {
    ...validationTypes.phone,
    onBlur: (e) => {
      setPhoneNumber(normalizeInput(e.target.value, phoneNumber));
    },
    onChange: (e) => {
      clearErrors(PHONE_REGISTER);
      let number = phoneNumberLengthValidation(e.target.value);
      if (number !== null) {
        if (
          number.length >= 11 &&
          (e.target.defaultValue == '' || e.target.defaultValue.length > 11)
        ) {
          number = normalizeInput(number);
        }
        setPhoneNumber(number);
      }
    },
  });

  const email = register(EMAIL_REGISTER, {
    ...validationTypes.email,
    onChange: (e) => {
      setValue(EMAIL_REGISTER, processEmailField(e.target.value));
      clearErrors(EMAIL_REGISTER);
    },
    onBlur: (e) => {
      setValue(EMAIL_REGISTER, cleanEmailField(e.target.value));
    },
  });

  const zip = register(ZIP_REGISTER, {
    ...validationTypes.zip,
    onChange: (e) => {
      setValue(ZIP_REGISTER, e.target.value);
      setZipCode(validateCode(e.target.value, zipCode, 5));
      clearErrors(ZIP_REGISTER);
    },
  });

  const frequency = register('frequency', {
    required: true,
    validate: (value) => value !== 'Order Frequency',
  });

  const comments = register(COMMENTS_REGISTER, {
    required: false,
  });
  const radioButton = register('radioButton', {
    required: true,
  });
  const handlePhoneNumber = (event) => {
    setPhoneNumber(event.target.value.replace(/\D/g, ''));
  };

  return (
    <div className={styles.supportFormsContainer}>
      <form onSubmit={handleSubmit(onSubmit)} id="form-frequency">
        <div className={styles.inputRowContainer}>
          <div className={styles.inputBoxContainerDouble}>
            <TextInput
              label="First Name"
              isDarkBorder={true}
              required={validationTypes.firstName.required}
              register={firstName}
              maxLength={validationTypes.firstName.maxLength}
              errors={errors}
              placeholder="First Name"
            />
          </div>
          <div className={styles.inputBoxContainerDouble}>
            <TextInput
              label="Last Name"
              required={validationTypes.lastName.required}
              register={lastName}
              isDarkBorder={true}
              maxLength={validationTypes.lastName.maxLength}
              errors={errors}
              placeholder="Last Name"
            />
          </div>
        </div>
        <div className={styles.inputRowContainer}>
          <div className={styles.inputBoxContainerDouble}>
            <TextInput
              type="tel"
              inputMode="numeric"
              register={phone}
              isDarkBorder={true}
              required={validationTypes.phone.required}
              label="Phone Number"
              placeholder="(XXX) XXX-XXXX"
              onFocus={handlePhoneNumber}
              onClickCapture={handlePhoneNumber}
              errors={errors}
              maxLength={validationTypes.phone.maxLength}
              value={phoneNumber}
            />
          </div>
          <div className={styles.inputBoxContainerDouble}>
            <TextInput
              required={validationTypes.email.required}
              register={email}
              label="Email Address"
              isDarkBorder={true}
              maxLength={validationTypes.email.maxLength}
              errors={errors}
              placeholder="Email Address"
            />
          </div>
        </div>
        <div className={styles.inputRowContainer}>
          <div className={styles.inputBoxContainerDouble}>
            <TextInput
              label="Zip Code"
              required={validationTypes.zip.required}
              register={zip}
              isDarkBorder={true}
              maxLength={validationTypes.zip.maxLength}
              errors={errors}
              placeholder="Zip Code"
              value={zipCode}
            />
          </div>
        </div>
        <div className={styles.inputRowContainer}>
          <div className={styles.inputBoxContainerSingle}>
            <label className={styles.formLabel}>
              My Order Frequency
              <div className={styles.fieldRequired}>*</div>
            </label>
            <div className={styles.stateDropdown}></div>
            {SelectDropdown(
              'frequency',
              'freq',
              frequencyOptions,
              frequency,
              'frequency',
              errors,
              clearErrors,
              'Order Frequency',
              false,
              false,
              false,
              'text',
              true,
              true
            )}
          </div>
        </div>
        <div className={styles.Pause_cancelContainer}>
          <label className={styles.formLabel}>
            Update my next order to adjust with my new frequency{' '}
            <div className={styles.fieldRequired}>*</div>
          </label>{' '}
          <div className={styles.radioButtonContainer}>
            <div
              className={styles.radioButton}
              onClick={() => setRadioButtonState(true)}
            >
              <input
                type="radio"
                value={true}
                {...radioButton}
                checked={radioButtonState}
                onChange={() => setRadioButtonState(true)}
                id="radio_Button"
              />
              <p className={styles.paragraph}>Yes, change my next order date</p>
            </div>

            <div
              className={styles.radioButton}
              onClick={() => setRadioButtonState(false)}
            >
              <input
                type="radio"
                value={false}
                checked={radioButtonState == false}
                {...radioButton}
                onChange={() => setRadioButtonState(false)}
                id="radio_Button"
              />
              <p className={styles.paragraph}>
                {' '}
                No, do not change my next order date.
              </p>
            </div>
          </div>
          {getValidationMessage(errors, 'radioButton')}
        </div>
        <div className={styles.questionsCommentsContainer}>
          <label>Comments/Questions</label>
          <div className={styles.questionsComments}>
            <TextAreaInput
              className={styles.questionTextArea}
              id="questionsComments"
              minRows={4}
              onChange={(e) => {
                clearErrors(COMMENTS_REGISTER);
              }}
              register={comments}
            />
          </div>
          <div className={styles.sendButtonContainer}>
            <ContainedButton
              btnType="dark"
              className={styles.submitRequestButton}
            >
              Submit Request
            </ContainedButton>
          </div>
        </div>
      </form>
    </div>
  );
};

export default FrequencyForm;
